module.exports = __webpack_public_path__ + "img/star-active.8332ea93.svg";